import styled from 'styled-components';

export const ActionDivider = styled.div`
  margin: 10px 0;
  width: 100%;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.12);
`;
